<template>
    <va-edit-layout>
        <SellerReviewEnrollmentPaymentEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></SellerReviewEnrollmentPaymentEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
